export { CrmOpportunityWorkbenchPage } from "./pages/CrmOpportunityWorkbenchPage";
export { CrmOpportunityWorkbenchFeaturePage } from "./ui";
export { QuickOpportunityDrawer } from "./ui";

/** 按需加载商机拆分页，避免后台主路由启动时执行拆分工作台依赖。 */
export function loadCrmOpportunitySplitPage() {
  return import("./pages/CrmOpportunitySplitPage");
}
